import type en from '../en/starlink'
import type { Translation } from '../types'

/** Starlink: the terminals, a site's and an event's cards, the business account */
const starlink: Translation<typeof en> = {
  "starlink.title": "Starlink-Terminals",
  "starlink.subtitle": "Die Starlink-Terminals des Unternehmens: ihr Standort oder ihre Veranstaltung, online, Datenverbrauch und ihr Dienst",
  "starlink.search": "Starlink-Terminals suchen",
  "starlink.refresh": "Aktualisieren",
  "starlink.refreshed": "Starlink-Konten gelesen",
  "starlink.refreshFailed": "Die Starlink-Konten wurden nicht gelesen",
  "starlink.addByKit": "Per Kit-Seriennummer hinzufügen",
  "starlink.addHint": "Ein Terminal mit privatem Tarif, ohne Geschäftskonto: Es zeigt, was Velanox darüber weiß — seinen Standort und seinen Mietartikel.",
  "starlink.kitSerial": "Kit-Seriennummer",
  "starlink.nickname": "Name (optional)",
  "starlink.add": "Hinzufügen",
  "starlink.added": "Starlink hinzugefügt",
  "starlink.addFailed": "Starlink nicht hinzugefügt",
  "starlink.none": "Noch keine Starlink-Terminals. Fügen Sie das Geschäftskonto des Unternehmens unter Unternehmenseinstellungen → Verbindungen hinzu oder fügen Sie ein Terminal per Kit-Seriennummer hinzu.",
  "starlink.col.terminal": "Terminal",
  "starlink.col.site": "Standort oder Veranstaltung",
  "starlink.col.online": "Online",
  "starlink.col.data": "Daten",
  "starlink.col.service": "Dienst",
  "starlink.online": "Online",
  "starlink.offline": "Offline",
  "starlink.lastRead": "Zuletzt gelesen {when}",
  "starlink.notRead": "Noch nicht gelesen",
  "starlink.noAccount": "Kein Konto",
  "starlink.notListed": "Nicht mehr in seinem Konto",
  "starlink.data": "{used} von {plan} GB",
  "starlink.dataNoLimit": "{used} GB",
  "starlink.serviceOn": "Ein",
  "starlink.serviceOff": "Aus",
  "starlink.serviceUnknown": "Unbekannt",
  "starlink.switching": "Wird geschaltet…",
  "starlink.event": "Veranstaltung: {name}",
  "starlink.linkToSite": "Mit Standort verknüpfen",
  "starlink.site": "Standort",
  "starlink.noSite": "Kein Standort",
  "starlink.linked": "Starlink verknüpft",
  "starlink.linkFailed": "Starlink nicht verknüpft",
  "starlink.save": "Speichern",
  "starlink.remove": "Entfernen",
  "starlink.removeConfirm": "{name} entfernen? Ein Terminal, das noch in seinem Konto ist, kommt beim nächsten Lesen ohne Standort zurück.",
  "starlink.removed": "Starlink entfernt",
  "starlink.removeFailed": "Starlink nicht entfernt",
  "starlink.card.lastSeen": "Zuletzt gesehen {when}",
  "starlink.card.neverSeen": "Noch nie etwas empfangen",
  "starlink.card.alerts": "Die Antenne meldet: {alerts}",
  "starlink.card.data": "Daten in diesem Abrechnungszeitraum",
  "starlink.card.noLimit": "Sein Tarif hat kein Datenlimit",
  "starlink.card.noData": "Kein Datenverbrauch bekannt",
  "starlink.card.service": "Dienst",
  "starlink.card.onConfirm": "Den Dienst dieses Starlink einschalten? Dafür können Kosten anfallen.",
  "starlink.card.offConfirm": "Den Dienst dieses Starlink ausschalten?",
  "starlink.card.switched": "Dienst geschaltet",
  "starlink.card.switchFailed": "Dienst nicht geschaltet",
  "starlink.card.inApp": "Schalten Sie ihn in der Starlink-App: Sein Tarif kann hier nicht pausiert werden.",
  "starlink.card.pending": "Starlink hat das Schalten noch nicht übernommen: Es wird alle 5 Minuten erneut versucht.",
  "starlink.card.noAccount": "Kein Geschäftskonto: Nutzen Sie die Starlink-App für den Datenverbrauch und den Dienst.",
  "starlink.eventCard.none": "Keine Starlink-Terminals bei dieser Veranstaltung.",
  "starlink.eventCard.switchedOn": "Eingeschaltet",
  "starlink.eventCard.switchedOff": "Ausgeschaltet",
  "starlink.eventCard.notTaken": "von Starlink nicht übernommen",
  "starlink.eventCard.withEvent": "mit der Veranstaltung",
  "starlink.eventCard.by": "von {name}",
  "starlink.eventCard.noSwitches": "Für diese Veranstaltung noch nicht geschaltet",
  "starlink.account.title": "Starlink-Geschäftskonto",
  "starlink.account.intro": "Die Client-ID und das Secret eines Dienstkontos des Starlink-Geschäftskontos des Unternehmens. Velanox liest seine Terminals alle 5 Minuten und schaltet ihren Dienst mit Ihren Veranstaltungen.",
  "starlink.account.name": "Name",
  "starlink.account.clientId": "Client-ID",
  "starlink.account.clientSecret": "Client-Secret",
  "starlink.account.secretKept": "Leer lassen, um das Secret zu behalten",
  "starlink.account.save": "Testen und speichern",
  "starlink.account.saved": "Starlink-Konto gespeichert",
  "starlink.account.terminals": "Terminals",
  "starlink.edit": "Bearbeiten",
  "starlink.saved": "Starlink gespeichert",
  "starlink.saveFailed": "Starlink nicht gespeichert",
  "starlink.dish.title": "Starlink-Antenne",
  "starlink.dish.auto": "Automatisch",
  "starlink.dish.wan": "Nur {wan}",
  "starlink.dish.off": "Aus",
  "starlink.dish.lookAgain": "Erneut suchen",
  "starlink.dish.looking": "Suche…",
  "starlink.dish.found": "Gefunden an {wan}",
  "starlink.dish.notFound": "Kein Starlink hinter diesem Router gefunden",
  "starlink.dish.failed": "Regeln konnten nicht geschrieben werden: {reason}",
  "starlink.dish.turnedOff": "Velanox sucht hinter diesem Router keine Starlink-Antenne",
  "starlink.dish.notChanged": "Die Einstellung der Starlink-Antenne wurde nicht geändert",
  "starlink.dish.block": "Antenne",
  "starlink.dish.signalOk": "Signal gut",
  "starlink.dish.signalLow": "Signal schwach",
  "starlink.dish.obstructed": "Verdeckt {pct} %",
  "starlink.dish.obstructedNow": "jetzt verdeckt",
  "starlink.dish.speed": "Download {down} · Upload {up} Mbit/s",
  "starlink.dish.latency": "Latenz {ms} ms",
  "starlink.dish.drop": "{pct} % der Pings verloren",
  "starlink.dish.stowed": "Eingeklappt",
  "starlink.dish.reachedVia": "Erreicht über {site}",
  "starlink.dish.notReachedSince": "Nicht erreicht seit {when}",
  "starlink.dish.notReached": "Nicht erreicht",
  "starlink.dish.reboot": "Neu starten",
  "starlink.dish.stow": "Einklappen",
  "starlink.dish.unstow": "Ausklappen",
  "starlink.dish.rebootConfirm": "Diese Antenne neu starten? Ihre Verbindung fällt für einige Minuten aus.",
  "starlink.dish.stowConfirm": "Diese Antenne einklappen? Sie legt sich flach und ihre Verbindung endet.",
  "starlink.dish.unstowConfirm": "Diese Antenne ausklappen?",
  "starlink.dish.done": "An die Antenne gesendet",
  "starlink.dish.actionFailed": "Die Antenne hat es nicht ausgeführt",
}

export default starlink
